import { cn } from 'cn';
import { type PropsWithChildren } from 'react';

type ColumnProps = PropsWithChildren & ComponentStyling;

export const Column = ({ children, className, style }: ColumnProps) => (
  <div className={cn('flex flex-col transition-all', className)} style={style}>
    {children}
  </div>
);

type ColumnHeaderProps = PropsWithChildren & ComponentStyling;

export const ColumnHeader = ({
  children,
  className,
  style,
}: ColumnHeaderProps) => (
  <h3
    className={cn(
      'border-b border-tiga-border-lighter p-2 text-center text-tiga-text-lighter',
      className,
    )}
    style={style}
  >
    {children}
  </h3>
);
